/**
 * Marca visible del producto (equipo interno y clientes).
 */
export const APP_BRAND_NAME = 'Indómito Hub';

/**
 * Organización asociada en pie de página y metadatos.
 */
export const APP_BRAND_ORG = 'Giras Indómito';

/**
 * Subtítulo en pantallas de autenticación.
 */
export const APP_BRAND_TAGLINE =
  'Gestión de programas y giras estudiantiles para equipos y clientes';

/**
 * Línea secundaria del encabezado cuando el usuario está autenticado.
 */
export const APP_NAVBAR_SUBTITLE =
  'Central para equipos internos y clientes de Giras Indómito';

/**
 * Prefijo corto para títulos de pestaña del navegador (alineado a marca GI).
 */
export const APP_ROUTE_TITLE_PREFIX = 'GI';

/**
 * Título sugerido del documento HTML; mantener alineado con `src/index.html`.
 */
export const APP_BROWSER_TITLE = `${APP_BRAND_NAME} | ${APP_BRAND_ORG}`;

/**
 * Texto para atributo `alt` de logos.
 */
export const APP_BRAND_LOGO_ALT = `Logo ${APP_BRAND_NAME}`;

/**
 * Etiqueta principal del pie legal (sin símbolo ©).
 */
export const APP_FOOTER_BRAND_LINE = `${APP_BRAND_NAME} · ${APP_BRAND_ORG.toUpperCase()}`;
